import { gql } from "@apollo/client";

export default gql`
  fragment Video on Race {
    video {
      liveStreaming
      onTvg
      onTvg2
      hasReplay
      streams
      replayFileName
      mobileAvailable
      isStreamHighDefinition
    }
  }
`;
